export function useAccommodation(code: string) {
  const isFreeweek = useFlag('freeweek')

  async function getImages(season: Season) {
    return (
      (await useWebccApi().accommodationImages(code, season)).data.value ?? []
    )
  }

  async function getVacancies(params?: Params) {
    const { data } = await useSearchApi().accommodationVacancies(code, {
      currency: useConfdata().currency,
      maxage: useRuntimeConfig().public.maxage.vacancies,
      freeweek: isFreeweek.value || undefined,
      ...params,
    })

    return data.value ?? undefined
  }

  return { getImages, getVacancies }
}
